import About from './about'
import Unauthorized from './unauthorized'
import Dashboard from './dashboard'
import FourOhFour from './404'

module.exports = {
  About,
  Dashboard,
  FourOhFour,
  Unauthorized
}



// WEBPACK FOOTER //
// ./src/views/core/index.js